/**
 * Currency domain types.
 * Pure TypeScript - no React imports.
 */

/**
 * Currency code (API returns dynamic list, so string not enum).
 */
export type CurrencyCode = string;

/**
 * Payment provider (aligns with BankAccountProvider).
 */
export type PaymentProvider = "stripe" | "flutterwave" | "paystack";

/**
 * Parameters for filtering currencies by payment provider.
 */
export interface CurrencyFilterParams {
  currencies: CurrencyCode[];
  provider: PaymentProvider | null;
}

/**
 * Fallback currencies when API is unavailable.
 */
export const FALLBACK_CURRENCIES: CurrencyCode[] = [
  "USD",
  "EUR",
  "GBP",
  "NGN",
  "KES",
  "CAD",
  "AUD",
];

/**
 * Non-EU currencies (Stripe does not support these).
 * Moved from src/utils/bank/index.ts.
 */
export const NON_EU_CURRENCIES: readonly CurrencyCode[] = [
  "NGN",
  "GHS",
  "KES",
  "UGX",
  "TZS",
  "ZAR",
  "GHS",
];
